import BookingService from "../services/booking.service";
import { TokenService } from "../services/storage.service";

const initialBookingError = {
	boolean: false,
	message: ''
}
const initialState = {
	currentDocSaleType: 'WHOLE',
	deleteBookingResponse: null,
	convertResponse: null,
	currentDocCurrency: TokenService.getDepCurrencyName(),
	currentBookingItems: [],
	bookingDocsList: [],
	bookingDocsTotal: 0,
	loading: false,
	fieldsForBookingList: [
		{
			key: 'id',
			label: 'goods.Id',
			visible: true,
			'class': 'min-60',
			changebale: false
		},
		{
			key: 'regDate',
			label: 'incomes.date',
			visible: true,
			'class': 'min-80',
			changebale: true
		},
		{
			key: 'expireDate',
			label: 'booking.booked-till',
			visible: true,
			'class': 'min-80',
			changebale: true
		},
		{
			key: 'regNumber',
			label: 'incomes.name',
			visible: true,
			'class': 'min-200',
			changebale: true
		},
		{
			key: 'contragentName',
			label: 'incomes.counteragent',
			visible: true,
			'class': 'min-150',
			changebale: true
		},
		{
			key: 'departmentName',
			label: 'incomes.department',
			class: 'min-150',
			visible: true,
			changebale: true
		},
		{
			key: 'comment',
			label: 'comment',
			'class': 'min-200',
			visible: true,
			changebale: true
		},
		{
			key: 'actions',
			label: 'incomes.actions',
			'class': 'table_actions min-60 fixed-col',
			visible: true,
			changebale: false
		}
	],
	currentDoc: {
		id: null,
		comment: '',
		status: 'DRAFT',
		departmentId: null,
		departmentName: '',
		contragentId: null,
		contragentName: '',
		regNumber: '',
		regDate: '',
		expireDate: '',
		bookingItemDtos: []
	},
	savedDoc: {
		id: null
	},
	bookingError: {
		boolean: false,
		message: ''
	}
}

const state = () => ({ ...initialState });

const getters = {

};

const actions = {
	async deleteBookingDocById({commit}, docId) {
		try {
			const response = await BookingService.deleteBookingDocById(docId);
			commit('setBookingError', initialBookingError);
			commit('setDeleteBookingResponse', response.data);
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setBookingError', {message: response.message, boolean: true});
			commit('setDeleteBookingResponse', null);
			return false
		}
	},
	async convertBookingToSale({commit}, bookingDoc) {
		try {
			const response = await BookingService.convertBookingToSale(bookingDoc);
			commit('setBookingError', initialBookingError);
			commit('setBookingConvertResponse', response.data);
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setBookingError', {message: response.message, boolean: true});
			commit('setBookingConvertResponse', null);
			return false
		}
	},
	async getBookingItemsByDocId({commit}, docId) {
		try {
			const response = await BookingService.getBookingItemsByDocId(docId);
			commit('setBookingError', initialBookingError);
			commit('setCurrentBookingItems', response.data);
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setBookingError', {message: response.message, boolean: true});
			commit('setCurrentBookingItems', initialState.currentBookingItems);
			return false
		}
	},
	async getBookingDocById({commit}, docId) {
		try {
			const response = await BookingService.getBookingDocById(docId);
			commit('setBookingError', initialBookingError);
			commit('setCurrentDoc', response.data);
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setBookingError', {message: response.message, boolean: true});
			commit('setCurrentDoc', initialState.currentDoc);
			return false
		}
	},
	async suspendBookingDoc({commit}, payload) {
		try {
			const response = await BookingService.suspendBookingDoc(payload);
			commit('setBookingError', initialBookingError);
			commit('setSavedDoc', response.data);
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setBookingError', {message: response.message, boolean: true});
			commit('setSavedDoc', initialState.currentDoc);
			return false
		}
	},
	async saveBookingDoc({commit}, payload) {
		try {
			const response = await BookingService.saveBookingDoc(payload);
			commit('setBookingError', initialBookingError);
			commit('setSavedDoc', response.data);
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setBookingError', {message: response.message, boolean: true});
			commit('setSavedDoc', initialState.currentDoc);
			return false
		}
	},
	async createBookingDoc({commit}, payload) {
		try {
			const response = await BookingService.createBookingDoc(payload);
			commit('setCurrentDoc', response.data);
		} catch (e) {
			commit('setCurrentDoc', initialState.currentDoc);
			return false
		}
	},
	async fetchBookingDocs({commit}, payload) {
		try {
			commit('setListLoading', true);
			const response = await BookingService.fetchBookingDocs(payload);
			commit('setListLoading', false);
			commit('setBookingDocsList', response.data)
			return true
		} catch (e) {
			commit('setListLoading', false);
			commit('setBookingDocsList', null)
			return false
		}
	}
};

const mutations = {
	setCurrentDocSaleType(state, payload) {
		state.currentDocSaleType = payload;
	},
	setDeleteBookingResponse(state, payload) {
		state.deleteBookingResponse = payload;
	},
	setBookingConvertResponse(state, payload) {
		state.convertResponse = payload;
	},
	setCurrentDocCurrency(state, payload) {
		state.currentDocCurrency = payload;
	},
	setCurrentBookingItems(state, payload) {
		state.currentBookingItems = payload;
	},
	setBookingError(state, payload) {
		state.bookingError.message = payload.message;
		state.bookingError.boolean = payload.boolean;
	},
	setSavedDoc(state, payload) {
		state.savedDoc = payload;
	},
	setCurrentDoc(state, payload) {
		state.currentDoc = payload;
	},
	setBookingDocsList(state, payload) {
		if (payload) {
			state.bookingDocsList = payload.bookingList;
			state.bookingDocsTotal = payload.total;
		} else {
			state.bookingDocsList = [];
			state.bookingDocsTotal = 0;
		}
	},
	setListLoading(state, booleanValue) {
		state.loading = booleanValue;
	}
};

export const booking = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
